import React from 'react';
import styles from './Layout.module.scss';
import { useStore } from 'contexts/store';
import { useHistory } from 'react-router-dom';
import { 
  Toolbar,
  Grid
} from '@material-ui/core';
import {
  StyledContainer,
  StyledAppBar,
  StyledBox
} from './styled';
import Search from '../../components/Search/Search';
import { SET_SEARCH_MOVIES } from '../../constants/store';

/**
 * Layout is responsible for basic app ui structure and wraps all the app subvompnents
 * @param {object} children
 * @return {*}
 * @final
*/
export const Layout = (props:any) => {
   let { dispatch } = useStore();
   const history = useHistory();

   const goTo = (route: string) => {
        dispatch({ type:SET_SEARCH_MOVIES,search_movies: [] });
        history.push(route);
        window.scrollTo(0, 0);
  };

 
   return (
      <StyledContainer fixed>
            <StyledAppBar position="sticky" color="primary">
              <Toolbar>
                 <Grid className={styles.inputWrapper} item xs={12}>
                  <Search />
                </Grid>
              </Toolbar>
           </StyledAppBar>
          <StyledBox>
            {props.children}
          </StyledBox>
      </StyledContainer>
    );
};